import React from 'react';
import { Box, Button, Typography, Paper } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';

class ChunkErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Check if it's a chunk loading error
    if (error?.name === 'ChunkLoadError' || error?.message?.includes('Loading chunk')) {
      return { hasError: true, error };
    }
    return { hasError: false };
  }

  componentDidCatch(error, errorInfo) {
    // Log chunk loading errors
    if (error?.name === 'ChunkLoadError') {
      console.error('Chunk loading failed:', error, errorInfo);
    }
  }

  handleRetry = () => {
    // Clear error and reload the page
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '60vh',
            p: 3
          }}
        >
          <Paper sx={{ p: 4, textAlign: 'center', maxWidth: 500 }}>
            <Typography variant="h5" gutterBottom color="error">
              Application Update Available
            </Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
              The application has been updated. Please refresh the page to load the latest version.
            </Typography>
            <Button
              variant="contained"
              color="primary"
              startIcon={<RefreshIcon />}
              onClick={this.handleRetry}
              size="large"
            >
              Refresh Page
            </Button>
          </Paper>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ChunkErrorBoundary; 